import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UseCase, Guard } from '@digibricks/core';
import { Title } from '../../../domain';
import { InvalidTitleLengthError } from './create-assignment.error';
export var CREATE_ASSIGNMENT_USE_CASE = 'CREATE_ASSIGNMENT_USE_CASE';
export var CreateAssignmentUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(CreateAssignmentUseCase, _UseCase);

  var _super = _createSuper(CreateAssignmentUseCase);

  function CreateAssignmentUseCase(formReleaseRepository) {
    var _this;

    _classCallCheck(this, CreateAssignmentUseCase);

    _this = _super.call(this);
    _this.formReleaseRepository = formReleaseRepository;
    return _this;
  }

  _createClass(CreateAssignmentUseCase, [{
    key: "validateBaseInput",
    value: function validateBaseInput(input) {
      var collection = [{
        argument: input.formInformation.id,
        argumentName: 'Form Information Id'
      }, {
        argument: input.title,
        argumentName: 'Title'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(collection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      } // Validate Title


      if (!Title.isValid(input.title)) {
        return new InvalidTitleLengthError();
      }

      return Result.ok();
    }
  }, {
    key: "createBaseInput",
    value: function () {
      var _createBaseInput = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var title, createFormReleaseUseCaseInput, createFormReleaseResponseOrError, formRelease, formInformation, defaultInput;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                title = input.title;
                createFormReleaseUseCaseInput = {
                  formId: input.formInformation.id
                };
                _context.next = 4;
                return this.formReleaseRepository.create(createFormReleaseUseCaseInput);

              case 4:
                createFormReleaseResponseOrError = _context.sent;

                if (!createFormReleaseResponseOrError.isFailure) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", Result.fail(createFormReleaseResponseOrError.error));

              case 7:
                formRelease = createFormReleaseResponseOrError.getValue();
                formInformation = {
                  id: input.formInformation.id,
                  formReleaseId: formRelease.id.toString(),
                  version: formRelease.version,
                  totalScore: formRelease.totalScore,
                  totalQuestions: formRelease.totalQuestions
                };
                defaultInput = {
                  formInformation: formInformation,
                  title: title
                };
                return _context.abrupt("return", Result.ok(defaultInput));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createBaseInput(_x) {
        return _createBaseInput.apply(this, arguments);
      }

      return createBaseInput;
    }()
  }]);

  return CreateAssignmentUseCase;
}(UseCase);